import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PortalPage, Card, LogoBox, Subtitle, Field, Msg, SubmitBtn, LinkBtn, Footer,
} from './corretorPortalStyles';
import {
  signInCorretor, requestCorretorPasswordReset, getCurrentCorretor,
} from '../services/corretorAuthService';
import { MF_BASE } from '../basePath';

export default function CorretorLoginPage() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login'); // login | forgot
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [busy, setBusy] = useState(false);

  // Se ja autenticado e aprovado, manda direto pro painel
  useEffect(() => {
    getCurrentCorretor().then(res => {
      if (res) navigate(`${MF_BASE}/corretor`, { replace: true });
    });
  }, [navigate]);

  const reset = () => { setError(''); setInfo(''); };

  const handleLogin = async (e) => {
    e.preventDefault();
    reset(); setBusy(true);
    const res = await signInCorretor(email, pass);
    setBusy(false);
    if (!res.ok) { setError(res.error); return; }
    navigate(`${MF_BASE}/corretor`, { replace: true });
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    reset();
    if (!email.trim()) { setError('Informe o email primeiro.'); return; }
    setBusy(true);
    const res = await requestCorretorPasswordReset(email);
    setBusy(false);
    if (!res.ok) { setError(res.error); return; }
    setInfo('Email de recuperação enviado. Confira sua caixa de entrada.');
  };

  return (
    <PortalPage>
      <Card onSubmit={mode === 'login' ? handleLogin : handleForgot}>
        <LogoBox>
          <img src="/mf-real-state/logos/mf-logo-dark.png" alt="MF Real Estate" />
        </LogoBox>
        <Subtitle>
          {mode === 'login' ? 'Área do corretor' : 'Recuperar senha'}
        </Subtitle>

        <Field>
          Email
          <input
            type="email" autoComplete="email"
            value={email}
            onChange={e => { setEmail(e.target.value); reset(); }}
            disabled={busy} autoFocus
          />
        </Field>

        {mode === 'login' && (
          <Field>
            Senha
            <input
              type="password" autoComplete="current-password"
              value={pass}
              onChange={e => { setPass(e.target.value); reset(); }}
              disabled={busy}
            />
          </Field>
        )}

        {error && <Msg>{error}</Msg>}
        {info && <Msg $ok>{info}</Msg>}

        <SubmitBtn type="submit" disabled={busy}>
          {busy ? 'Aguarde...' : mode === 'login' ? 'Entrar' : 'Enviar link'}
        </SubmitBtn>

        {mode === 'login' ? (
          <LinkBtn type="button" onClick={() => { reset(); setMode('forgot'); }}>
            Esqueci minha senha
          </LinkBtn>
        ) : (
          <LinkBtn type="button" onClick={() => { reset(); setMode('login'); }}>
            Voltar ao login
          </LinkBtn>
        )}

        <Footer>MF Real Estate · Corretores</Footer>
      </Card>
    </PortalPage>
  );
}
